export default __webpack_public_path__ + "static/media/ord-tp-nv.a8f7a26e.png";